<template>
  <div class="row">
    <div class="col-6">
      <CheckupHistory :doctor="getUser.doctor"/>
    </div>
    <div class="col-6">
      <PaymentsHistory :doctor="getUser.doctor"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import CheckupHistory from "@/components/doctor/CheckupHistory/CheckupHistory";
import PaymentsHistory from "@/components/doctor/PaymentsHistory/PaymentsHistory";

export default {

  name: "History",
  components: {PaymentsHistory, CheckupHistory},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('doctorAuth', ['getUser'])
  },
  methods: {},
  mounted() {
  }
}

</script>

<style scoped>

</style>
